import logoUrl from '../assets/PRNlogo.svg'

const Header = () => {
  return (
    <header className="bg-white border-b border-slate-200 shadow-sm">
      <div className="mx-auto px-8 py-4">
        <div className="flex items-center gap-3">
          <img
            src={logoUrl}
            alt="PickRightNow logo"
            className="h-9 w-9 rounded-full object-cover shadow-sm border border-slate-200"
          />
          <h1 className="text-xl font-bold text-slate-900">小转盘</h1>
        </div>
      </div>
    </header>
  )
}

export default Header

